import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import ServiceCentersComponent from "@/pages/serviceCenters/ServiceCentersComponents/ServiceCentersComponent/ServiceCentersComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { FIELDS } from "@/pages/serviceCenters/ServiceCentersComponents/utlis";
import useHelpers from "@hooks/useHelpers";
import { api__getAvailableSCData } from "@/apis/cars-service-centers/cars-services-centers";
import useApi from "@hooks/useApi";
var ServiceCenters = function ServiceCenters() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useApi = useApi([], api__getAvailableSCData),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    availableSCData = _useApi2[2];

  //-----------------------------------------------------------
  var _useState = useState(FIELDS),
    fields = _useState[0],
    setFields = _useState[1];
  //-----------------------------------------------------------
  var handleFieldsChange = function handleFieldsChange(data) {
    var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var newFields = _objectSpread({}, fields);
    newFields[fieldName] = {
      name: data.name,
      value: data.key,
      error: ""
    };
    if (fieldName === "make_id" && data.name === "") {
      newFields["city_id"] = {
        name: "",
        value: "",
        error: ""
      };
      newFields["dealership_name"] = {
        name: "",
        value: "",
        error: ""
      };
    }
    if (fieldName === "city_id" && data.name === "") {
      newFields["dealership_name"] = {
        name: "",
        value: "",
        error: ""
      };
    }
    setFields(newFields);
    if (fieldName === "make_id" && data.name === "" || fieldName === "city_id" && data.name === "" && fields.dealership_name.value === "") return;
    // dispatch(
    //   getAvailableSCData(
    //     Object.entries(newFields).map((item) => `${item[0]}=${item[1].value}`)
    //   )
    // );
  };
  //-----------------------------------------------------------
  var handleSubmit = function handleSubmit() {
    var params = Object.entries(fields).map(function (item) {
      return "".concat(item[0], "=").concat(item[1].value);
    });
    navigateTo("/service-centers/filters?".concat(params.join("&")));
  };
  //-----------------------------------------------------------
  return /*#__PURE__*/React.createElement(Layout, {
    authenticationMsg: true,
    mainClass: "",
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    disableLoader: true,
    hideAppBanner: true,
    hideFooterWithoutAuthMsg: true
  }, /*#__PURE__*/React.createElement(ServiceCentersComponent, {
    availableSCData: availableSCData,
    onFieldChange: handleFieldsChange,
    fields: fields,
    onSubmit: handleSubmit,
    loading: loading
  }));
};
export default ServiceCenters;